import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { createExternalGroupRelationAction } from '../actions';
import { egrSchema, transformErrorMessage } from '../utils/egrSchema';

import { DateField, transformDateToDB } from '../utils/dateFieldUtils';
import BulkImport from './BulkImport';

class EgrCreateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formTriggered: false
    };
    this.initialFormValues = {
      groupId:             '',
      externalGroupId:     '',
      externalGroupTypeCd: this.props.permittedTypeCodes[0],
      stateCd:             '',
      effectiveStartDate:  '',
      effectiveEndDate:    ''
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isCreating && !this.props.isCreating && _.isEmpty(this.props.errors)) {
      this.triggerCreateForm();
    }
  }

  triggerCreateForm() {
    this.setState({ formTriggered: !this.state.formTriggered });
  }

  newEgr(values, actions) {
    const args = {
      group_id:               values.groupId,
      external_group_id:      values.externalGroupId,
      external_group_type_cd: values.externalGroupTypeCd,
      state_cd:               values.stateCd,
      effective_start_dt:     transformDateToDB(values.effectiveStartDate),
      effective_end_dt:       transformDateToDB(values.effectiveEndDate)
    };
    this.props.createExternalGroupRelationAction({ args });
  }

  formErrors() {
    return _.get(this.form, ['state', 'errors']);
  }

  generateErrorContainer(errors) {
    if (_.isEmpty(errors)) {
      return;
    }
    const names = ['groupId', 'externalGroupId', 'externalGroupTypeCd',
      'stateCd', 'effectiveStartDate', 'effectiveEndDate'];
    return (
      <div className="error">
        {names.map(name => (
          <ErrorMessage name={name} key={name}>
            {msg => <div>{transformErrorMessage(msg)}</div>}
          </ErrorMessage>
        ))}
      </div>
    );
  }

  generateCreateForm() {
    return (
      <div>
        {this.state.formTriggered &&
          <React.Fragment>
            <Formik
              ref={node => this.form = node}
              initialValues={this.initialFormValues}
              onSubmit={(values, actions) => this.newEgr(values, actions)}
              validateOnBlur={false}
              validateOnChange={false}
              validationSchema={egrSchema}
            >
              {({ errors }) => (
                <div>
                  <h2>Create External Group Relation</h2>
                  {this.generateErrorContainer(errors)}
                  <Form>
                    <div className="egr_create_fields">
                      <div className="label_container">
                        <label htmlFor="groupId">Group Id</label>
                        <label htmlFor="externalGroupId">Vendor Group Id</label>
                        <label htmlFor="externalGroupTypeCd">External Group Type</label>
                        <label htmlFor="stateCd">State Restriction</label>
                        <label htmlFor="effectiveStartDate">Effective Start Date</label>
                        <label htmlFor="effectiveEndDate">Effective End Date</label>
                      </div>
                      <div className="field_container">
                        <Field type="text" name="groupId" />
                        <Field type="text" name="externalGroupId" />
                        <Field component="select" name="externalGroupTypeCd">
                          {this.props.permittedTypeCodes.map((code, index) => (
                            <option value={code} key={index}>{code}</option>
                          ))}
                        </Field>
                        <Field component="select" name="stateCd">
                          <option />
                          {this.props.stateCodes.map(([state, code], index) => (
                            <option value={code} key={index}>{state}</option>
                          ))}
                        </Field>
                        <Field
                          name="effectiveStartDate"
                          render={({ field }) => (
                            <DateField field={field} />
                          )}
                        />
                        <Field
                          name="effectiveEndDate"
                          render={({ field }) => (
                            <DateField field={field} />
                          )}
                        />
                      </div>
                    </div>
                    <div className="button_container">
                      <button
                        className="button"
                        type="submit"
                        disabled={this.props.isCreating}
                      >
                        {this.props.isCreating ? 'Submitting ...' : 'Submit'}
                      </button>
                      <button
                        className="button secondary"
                        type="button"
                        onClick={() => this.triggerCreateForm()}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                </div>
              )}
            </Formik>
            <BulkImport />
          </React.Fragment>}
      </div>
    );
  }

  render() {
    return (
      <div className="egr_create">
        {this.props.hasBillingAccess && !this.state.formTriggered  &&
          <button
            className="button egr_create_button"
            onClick={() => this.triggerCreateForm()} type="button"
          >
            New Group Relation
          </button>
        }
        {this.generateCreateForm()}
      </div>
    );
  }
}

EgrCreateForm.propTypes = {
  stateCodes:                        PropTypes.array,
  permittedTypeCodes:                PropTypes.array,
  createExternalGroupRelationAction: PropTypes.func,
  isCreating:                        PropTypes.bool,
  errors:                            PropTypes.array,
  hasBillingAccess:                  PropTypes.bool
};

const mapStateToProps = state => ({
  isCreating: state.egrReducer.isCreating,
  errors:     state.egrReducer.errors
});
const mapDispatchToProps = { createExternalGroupRelationAction };

export default connect(mapStateToProps, mapDispatchToProps)(EgrCreateForm);
